import React from "react";
import { useField } from "formik";
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  SelectProps,
} from "@mui/material";

interface OptionType {
  [key: string]: any;
}

type DitSelectProps = {
  name: string;
  label?: string;
  valueKey?: string | null;
  nameKey?: string | null;
  addOption?: boolean;
  required?: boolean;
  placeholder?: string;
  options: OptionType[];
} & SelectProps;

const DitSelect: React.FC<DitSelectProps> = ({
  label,
  name,
  valueKey = null,
  nameKey = null,
  addOption = false,
  required = false,
  placeholder = "",
  options = [],
  ...props
}) => {
  const [field, meta] = useField(name);
  const errorText = meta.touched && meta.error ? meta.error : "";
  const labelId = `${name}-label`;

  return (
    <FormControl fullWidth error={!!errorText} size="small" sx={{ mb: 2 }}>
      {label && (
        <label style={{ marginBottom: 2, fontSize: 14 }}>
          {label}
          {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <Select
        labelId={labelId}
        id={name}
        {...field}
        {...props}
        displayEmpty={addOption}
      >
        {addOption && (
          <MenuItem value="">
            <em>{`Select ${placeholder || label}`}</em>
          </MenuItem>
        )}
        {options.map((option, index) => {
          const value =
            (valueKey && option[valueKey]) ?? option.value ?? option.id ?? "";
          const display =
            (nameKey && option[nameKey]) ??
            option.label ??
            option.name ??
            value;
          return (
            <MenuItem key={`${value}${index}`} value={value}>
              {display}
            </MenuItem>
          );
        })}
      </Select>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};

export default DitSelect;
